module.exports = __webpack_public_path__ + "img/top.9b1c9c88.png";